import HTTP from './http-interceptor';
import { DESAFIO_EQUIPO } from '../constants';

const TeamChallengeService = {
    
    getStatus: (area, team, player) => {
        return HTTP.get(`${DESAFIO_EQUIPO.ESTATUS}${area}/${team}/${player}`);
    },
    nextRound: (area, team, player) => {
        return HTTP.get(`${DESAFIO_EQUIPO.SIGUIENTE_RONDA}${area}/${team}/${player}`);
    },
    leaderboard: (area, team, player) => {
        return HTTP.get(`${DESAFIO_EQUIPO.TABLERO}${area}/${team}/${player}`);
    },
    save: (area, team, player, data) => {
        return HTTP.post(`${DESAFIO_EQUIPO.GUARDA_ESTADISTICA}${area}/${team}/${player}`, data );
    },
}

export default TeamChallengeService;